import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import SmallDetails from "./SmallDetails";
import { getCityStateCountry } from "shared/utils/addressUtils";
import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";
import { BookkeepingSidePanel } from "components/SidePanel/Bookkeeping/BookkeepingSidePanel";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import { BankAccountSidePanel } from "components/SidePanel/BankAccount/BankAccountSidePanel";
import FormattedAddress from "components/Atoms/FormattedAddress";

interface ContactSmallProps {
  contact: server.dto.ContactSmallV2
}

export const ContactSmallDetails = (props: ContactSmallProps) => {
  return <SmallDetails
    label={<ContactSidePanel
      contactId={props.contact.contactId}
      trigger={<a tabIndex={0}>{props.contact.name.fullName}</a>}
    />}
  />
}

export type LayoutType = "multiLine" | "singleLine";
interface CompanySmallProps {
  company: server.dto.CompanySmall
  layout: LayoutType
  onChange?: () => void
}

export const CompanySmallDetails = (props: CompanySmallProps) => {
  if (props.layout === "singleLine") return <SmallDetails
    label={<CompanySidePanel
      companyId={props.company.companyId}
      trigger={<a tabIndex={0}>{props.company.name}</a>}
      onChange={props.onChange}
    />}
    subLabel={getCityStateCountry(props.company.address)}
  />

  return <div>
    <CompanySidePanel
      companyId={props.company.companyId}
      trigger={<a tabIndex={0}>{props.company.name}</a>}
      onChange={props.onChange}
    />
    <FormattedAddress address={props.company.address} />
  </div>
}
  ;

interface InvoiceSmallProps {
  invoice: server.dto.InvoiceSmall
}

export const InvoiceSmallDetails = (props: InvoiceSmallProps) =>
  <SmallDetails
    label={props.invoice.documentNumber}
    link={props.invoice.isV1
      ? routes.invoiceV1_Detail(props.invoice.invoiceId).absolute
      : routes.invoiceV2_Detail(props.invoice.invoiceId).absolute}
  />;

interface BookkeepingSmallProps {
  bookkeeping: server.dto.BookkeepingSmall
}

export const BookkeepingSmallDetails = (props: BookkeepingSmallProps) =>
  <SmallDetails
    label={<BookkeepingSidePanel
      bookkeepingId={props.bookkeeping.bookkeepingId}
      trigger={<a tabIndex={0}>{props.bookkeeping.name}</a>}
    />}
    subLabel={props.bookkeeping.code}
  />

interface BankAccountSmallProps {
  bankAccount: server.dto.BankAccountSmall
}

export const BankAccountSmallDetails = (props: BankAccountSmallProps) =>
  <SmallDetails
    label={<BankAccountSidePanel
      bankAccountId={props.bankAccount.bankAccountId}
      trigger={<a tabIndex={0}>{props.bankAccount.title}</a>}
    />}
    subLabel={props.bankAccount.beneficiaryName}
  />